import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants, { WebsiteConstants } from '../../../data/Constants';
import './style.scss';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import { useMemo } from 'react';
import { LocationOn } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const { translate } = useLanguageContext();
    const navigate = useNavigate();


    const address = WebsiteConstants.address;

    const contacts = useMemo(() => {
        return WebsiteConstants.contacts.filter(c => c.link !== undefined);
    }, []);


    const socialMedias = useMemo(() => {
        return WebsiteConstants.socialMedias.filter(s => s.link !== undefined);
    }, []);


    return <Box className='grid-content-section' id='footer'>
        <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
            <Grid item lg={4} md={6} xs={12}>
                <Typography variant='subtitle1' className='text-footer fontsize-20 fontweight-bold'>
                    {translate("talkToUs")}
                </Typography>

                <Box className='display-flex flexdirection-column gap-8' paddingTop={1} paddingBottom={4}>
                    <Typography 
                        variant='subtitle2' 
                        component='a' 
                        className='text-footer text-contact' 
                        href={address.googleMaps} 
                        target='_blank'
                    >
                        <LocationOn />
                        {address.street}, {address.number} - {address.neighborhood}, {address.city}, {address.zipCode}
                    </Typography>

                    {
                        contacts.map((c, index) => {
                            return <Typography 
                                variant='subtitle2' 
                                component='a' 
                                className={`text-footer text-contact ${c.className}`} 
                                href={c.link} 
                                target='_blank'
                                key={index}
                            >
                                <c.icon />
                                {c.label}
                            </Typography>;
                        })
                    }
                </Box>
            </Grid>

            <Grid item lg={4} md={6} xs={12}>
                <Typography variant='subtitle1' className='text-footer fontsize-20 fontweight-bold'>
                    {translate("destinations")}
                </Typography>

                <Grid item className='display-flex flexdirection-column gap-8' paddingTop={1}>
                    {
                        WebsiteConstants.otherDestinations.map((d, index) => {
                            const className = false ? 'active' : '';

                            return (
                                <Button className={`button-destination ${className}`} onClick={() => navigate(`/${d.key}`)} key={index}>
                                    <LocationOn />
                                    <Typography className='destination-city'>
                                        {d.city}
                                        <Typography className='destination-state'>{d.state}</Typography>
                                    </Typography>
                                </Button>
                            );
                        })
                    }
                </Grid>
            </Grid>

            {
                socialMedias.length > 0 && <>
                    <Grid item lg={4} md={6} xs={12}>
                        <Typography variant='subtitle1' className='text-footer fontsize-20 fontweight-bold'>
                            {translate("socialMedias")}
                        </Typography>

                        <Typography variant='subtitle1' className='text-footer fontsize-14 lineheight-20'>
                            {translate("socialMediasDescription")}
                        </Typography>

                        <Grid item className='display-flex gap-8 flexwrap-wrap' paddingTop={1}>
                            {
                                socialMedias.map((s, index) => {
                                    return <IconButton className='iconbutton-socialmedia' onClick={() => window.open(s.link)} key={index}>
                                        <s.icon />
                                    </IconButton>;
                                })
                            }
                        </Grid>
                    </Grid>
                </>
            }
        </Grid>
    </Box>;
}

export default Footer;